// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/image/noDataPic.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".noListData[data-v-114f90c8] {\n  display: flex;\n  justify-content: center;\n  padding: 9.375rem;\n}\n.noListData .no-img[data-v-114f90c8] {\n  width: 23.375rem;\n  height: 25.75rem;\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") center center no-repeat;\n}\n.noListData .no-text[data-v-114f90c8] {\n  margin-top: -1.25rem;\n  text-align: center;\n  font-size: 1.25rem;\n}", ""]);
// Exports
module.exports = exports;
